














































/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ButtonConfig, ButtonType } from "../../../Models/Buttons";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";

import axios from "axios";
import { IIssueConversionService } from "../../../BusinessServices/issueconversion";
import PdfUploader from "../../../Ui-Components/Uploader/PdfUploader.vue";
import ParticaTitleBase from "../../Base/ParticaTitleBase.vue";
import { IPublicationService } from "../../../BusinessServices/publication";
import { PublicationModel, BlobReplaceDTO, IssueModel } from "../../../Generated/ParticaAPI";
import { IIssueService } from "../../../BusinessServices/issue";


@Component(
	{
		name: "IssueCreatePdf",
		components: {
			ButtonList,
			ParticaCard,
			ParticaView,

			PdfUploader
		}
	})
export default class IssueCreatePdf extends ParticaTitleBase {
	@Prop() private id: number;
	private files: File[] = [];
	private uploadProgress: { [key: string]: { state: string; percentage: number } } = {};
	private uploading = false;
	private successfullUploaded = false;
	private multiple = true;
	private publicationService: IPublicationService;
	private title: PublicationModel = new PublicationModel();
	private conversionService: IIssueConversionService;
	private issueService: IIssueService;
	private maxFiles: number = 3;

	private buttons: ButtonConfig[] = [
		// { label: "Add new title", action: eParticaAction.ISSUE_ADD, type: ButtonType.Normal } as ButtonConfig,
	];
	private options: ButtonConfig[] = [
		{ label: "Create single issue with multiple PDFs", action: eParticaAction.ISSUE_ADD, type: ButtonType.Normal } as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.PDF_UPLOAD: {
					this.files = event.item as File[];
					await this.uploadFiles();
					break;
				}
				case eParticaAction.ISSUE_ADD: {
					this.navigate("issuecreatemultiplepdf",  { id: this.id.toString() } );
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}

	@Watch("route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Create Issue via PDF upload";
		this.ShowSnackbar("Create an issue with every PDF uploaded. You can only upload a maximum 3 issues (pdfs) at a time. Click the help button for more information.");
		await this.init();
		await this.getTitleNav(this.id);
	}

	private async init() {
		try {
			this.LoadingStart();
			this.publicationService = this.particaServices.getPublicationService();
			this.conversionService = this.particaServices.getIssueConversionService();
			this.issueService = this.particaServices.getIssueService();
			this.title = await this.publicationService.getTitle(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}

	private async uploadFile(file: File, promises: Promise<any>[]) {
		const issueName = file.name.substring(0, file.name.length - 4);
		const issue: IssueModel = await this.issueService.CreateEmptyIssue(this.id, issueName);
		const blobsas: BlobReplaceDTO = await this.conversionService.getSourceBlob(issue.id as number);
		this.uploadProgress[file.name] ? this.uploadProgress[file.name].state : "idle";
		this.uploadProgress[file.name] ? this.uploadProgress[file.name].percentage : 0;
		promises.push(this.sendRequest(file, blobsas.sas as string, blobsas.blob as string, issue.id as number));
	}

	private async uploadFiles() {
		// get environment conversion path, sas
		this.uploading = true;
		this.uploadProgress = {};
		const promises: Promise<any>[] = [];

		try {
			for (const file of this.files) {
				await this.uploadFile(file, promises);
			}
			await Promise.all(promises);
			// delay starting processing tto ensure file is available.
			// await new Promise(resolve => setTimeout(resolve, 2000));
			promises.forEach(promise => {
				promise.then(async (id) => {
					await this.conversionService.restartIssue(id);
				});
			});
			// this.uploading = false;
			// this.successfullUploaded = true;
			// await this.conversionService.restartIssue(this.id);
			this.ShowSnackbar(`Issue(s) created. The issue(s) will now be processed.`);
		} catch (error) {
			this.ShowErrorDialog(error, "Error uploading PDF.");
			this.uploading = false;
			// Just do this for now...
			this.successfullUploaded = true;
		}
	}
	private sendRequest(file: File, sas: string, path: string, id: number) {
		return new Promise((resolve, reject) => {
			const config: any = {
				baseUrl: path,
				sasToken: sas,
				file,
				progress: (data: any) => {
					this.uploadProgress[file.name] = { state: "pending", percentage: data };
					this.uploadProgress = { ...this.uploadProgress };
				},
				complete: (data: any) => {
					resolve(id);
				},
				error: (data: any) => {
					reject(data);
				}
			};
			// @ts-ignore
			return this.$azureUpload(config, axios.create({
				transformRequest: [
					(data, headers) => {
						delete headers.common.Authorization;
						return data;
					}
				]
			}));
		});
	}
}
